import BackButton from '../components/BackButton';
import { useEffect, useState } from 'react';
import { useApp } from '../App';
import api from '../api';
import Loading from '../components/Loading';
import { useI18n } from '../i18n/index.jsx';

export default function AdminInvoices() {
  const { isAdmin, isSuperuser } = useApp();
  const { t } = useI18n();
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [filter, setFilter] = useState('pending_verification');
  const [msg, setMsg] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewLoading, setPreviewLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');

  useEffect(() => { if (isAdmin) load(); }, [isAdmin, filter]);

  async function load() {
    setLoading(true);
    try {
      const q = filter === 'all' ? '' : `?status=${filter}`;
      const { data } = await api.get(`/admin/invoices/out${q}`);
      setInvoices(data || []);
    } catch (e) {
      setMsg(e.userMessage || 'Ошибка');
    } finally {
      setLoading(false);
    }
  }

  async function verify(id, status) {
    try {
      await api.post(`/admin/invoices/out/${id}/verify?status=${status}`);
      load();
    } catch (e) {
      setMsg(e.userMessage || 'Ошибка');
    }
  }

  async function openPreview(id) {
    setPreviewLoading(true);
    try {
      const res = await api.get(`/invoices/out/${id}/pdf`, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPreviewUrl(url);
      setDownloadUrl(url);
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка загрузки PDF');
    } finally {
      setPreviewLoading(false);
    }
  }

  function closePreview() {
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setPreviewUrl('');
    setDownloadUrl('');
  }

  async function markProformaPaid(id) {
    try {
      await api.post(`/admin/invoices/out/${id}/proforma-paid`);
      setMsg('✅ Proforma отмечена как оплаченная');
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  async function deleteInvoice(id) {
    if (!confirm('Удалить фактуру?')) return;
    try {
      await api.delete(`/admin/invoices/out/${id}`);
      setMsg('🗑 Фактура удалена');
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  if (!isAdmin) return <div className="page"><BackButton /><h2>⛔ Доступ запрещён</h2></div>;
  if (loading) return <Loading />;

  return (
    <div className="page"><BackButton />
      <h1>🧾 Фактуры (админ)</h1>
      {msg && <div className="message">{msg}</div>}

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="pending_verification">На проверке</option>
          <option value="verified">Верифицированы</option>
          <option value="rejected">Отклонены</option>
          <option value="proforma">Proforma</option>
          <option value="all">Все</option>
        </select>
        <button className="btn btn-secondary" onClick={load}>🔄 Обновить</button>
      </div>

      {invoices.length === 0 ? <div className="empty">Нет фактур</div> : (
        <div className="list">
          {invoices.map(inv => (
            <div key={inv.id} className="list-item" style={{ alignItems: 'center' }}>
              <div className="list-main">
                <div className="list-title">{inv.invoice_number}</div>
                <div className="list-sub">{inv.user_name || '—'} • TG: {inv.telegram_id || '—'}</div>
                <div className="list-sub">{inv.buyer_name} • {inv.issue_date}</div>
              </div>
              <div className="list-right">
                <div className={`status-badge status-${inv.status}`}>{inv.status}</div>
                <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                  {inv.status !== 'proforma' && (
                    <>
                      <button className="btn btn-tiny" onClick={() => verify(inv.id, 'verified')}>✅</button>
                      <button className="btn btn-tiny" onClick={() => verify(inv.id, 'rejected')}>❌</button>
                    </>
                  )}
                  {inv.status === 'proforma' && isSuperuser && (
                    <button className="btn btn-tiny" onClick={() => markProformaPaid(inv.id)}>💰</button>
                  )}
                  {isSuperuser && (
                    <button className="btn btn-tiny" onClick={() => deleteInvoice(inv.id)}>🗑</button>
                  )}
                  <button className="btn btn-tiny" onClick={() => openPreview(inv.id)} disabled={previewLoading} style={{ background: '#fff', color: '#111' }}>PDF</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {previewUrl && (
        <div className="modal-overlay" onClick={closePreview}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ width: '90%', maxWidth: 900, height: '80vh' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <h3 style={{ margin: 0 }}>Просмотр фактуры</h3>
              <div style={{ display: 'flex', gap: 8 }}>
                {downloadUrl && (
                  <a className="btn btn-secondary" href={downloadUrl} download={`invoice_${Date.now()}.pdf`}>Скачать PDF</a>
                )}
                <button className="btn btn-secondary" onClick={closePreview}>{t('common.close')}</button>
              </div>
            </div>
            <iframe title="invoice-preview" src={previewUrl} style={{ width: '100%', height: '100%', border: 'none', borderRadius: 8 }} />
          </div>
        </div>
      )}
    </div>
  );
}
